import { render, staticRenderFns } from "./singleProduct.vue?vue&type=template&id=1198ad66&scoped=true&"
import script from "./singleProduct.vue?vue&type=script&lang=js&"
export * from "./singleProduct.vue?vue&type=script&lang=js&"
import style0 from "./singleProduct.vue?vue&type=style&index=0&id=1198ad66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198ad66",
  null
  
)

export default component.exports